import React, { Component } from "react";
import {
  Layout,
  Input,
  Row,
  Col,
  Spin,
  message,
} from "antd";
import {
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  LockOutlined,
  TikTokOutlined,
  WhatsAppOutlined,
  XOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import logoB from "../../assets/Biwo_bienvenida.png";
import logoGrande from "../../assets/Biwo logo grande.png";
import bienvenidaLogin from "../../assets/Bienvenida-Banner-Biwo.png";
import { FormItem, Form, ErrorItem, ButtonItem } from "../../Components/Items";
import axios from "axios";

const { Content } = Layout;

class CambiarContrasena extends Component {
  state = {
    loading: false,
  };

  onFinish(values) {
    this.setState({ loading: true });
    if (values.password === values.confirmarcontraseña) {
      const url = new URL(window.location.href);
      const token = url.searchParams.get("token");
      axios
        .post(
          "/cambiarContrasena",
          { ...values, token },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Se ha cambiado la contraseña");
            this.props.history.push("/login");
          } else if (res.data.success === 1) {
            message.warning(res.data.message);
          } else {
            message.error(
              "Hubo un error y no pudimos cambiar la contraseña, porfavor comuniquese con nosotros"
            );
          }
        });
    } else {
      this.setState({ loading: false });
      message.error("Las contraseñas no coinciden");
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    return (
      <Layout id="login-layout">
        <Content>
          <Row id="login-row">

            {/* Banner izquierdo */}
            <Col xs={0} sm={0} lg={13} xl={13} id="login-col-imagen">
              <div id="login-imagen-card">
                <img
                  src={bienvenidaLogin}
                  alt="Biwo"
                  id="login-imagen"
                />
                <div className="login-glass-card">
                  <p className="login-glass-text">
                    Ingresa tu nueva contraseña para recuperar el acceso a tu cuenta{" "}
                    <span className="login-glass-highlight">Biwo</span>
                  </p>
                </div>
              </div>
            </Col>

            {/* Formulario */}
            <Col xs={24} sm={24} lg={11} xl={11} id="login-col-form">
              <div className="login-form-container">

                <div
                  className="login-header-section"
                  style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                >
                  <h1 style={{ color: "#36B9D0", marginBottom: "-110px", fontWeight: "bold", fontSize: "50px" }}>
                    Restablece tu
                  </h1>
                  <img src={logoB} alt="Biwo" className="login-logo-desktop" style={{ width: "32.0rem", marginTop: "20px" }} />
                  <img src={logoGrande} alt="Biwo" className="login-logo-mobile" style={{ marginTop: "15px", marginBottom: "50px" }} />
                </div>

                <Spin spinning={this.state.loading} size="large">
                  <Form
                    defaultBehavior
                    name="cambiarContrasena"
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                  >
                    <FormItem name="password" pattern required max={200} min={5}>
                      <Input.Password
                        prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                        placeholder="Nueva contraseña"
                        size="large"
                      />
                    </FormItem>
                    <FormItem name="confirmarcontraseña" pattern required max={200} min={5}>
                      <Input.Password
                        prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                        placeholder="Confirmar contraseña"
                        size="large"
                      />
                    </FormItem>
                    <FormItem style={{ marginTop: "0", marginBottom: "4px" }}>
                      <ButtonItem
                        htmlType="submit"
                        type="primary"
                        cyan
                        style={{
                          height: "44px",
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                      >
                        Cambiar Contraseña
                      </ButtonItem>
                    </FormItem>
                  </Form>
                </Spin>

                <div className="login-bottom-section">
                  <hr className="login-divider" />
                  <div className="login-social-row">
                    <a href="https://www.facebook.com/biwoerp" target="_blank" rel="noopener noreferrer">
                      <FacebookOutlined style={{ fontSize: "18px", color: "#3b5998" }} />
                    </a>
                    <a href="https://www.instagram.com/biwo_erp" target="_blank" rel="noopener noreferrer">
                      <InstagramOutlined style={{ fontSize: "18px", color: "#e1306c" }} />
                    </a>
                    <a href="https://www.linkedin.com/company/erp-biwo" target="_blank" rel="noopener noreferrer">
                      <LinkedinOutlined style={{ fontSize: "18px", color: "#0077b5" }} />
                    </a>
                    <a href="https://x.com/ERP_BIWO" target="_blank" rel="noopener noreferrer">
                      <XOutlined style={{ fontSize: "18px", color: "#000" }} />
                    </a>
                    <a href="https://www.tiktok.com/@biwo_erp" target="_blank" rel="noopener noreferrer">
                      <TikTokOutlined style={{ fontSize: "18px", color: "#000" }} />
                    </a>
                    <a href="https://wa.me/524448923732" target="_blank" rel="noopener noreferrer">
                      <WhatsAppOutlined style={{ fontSize: "18px", color: "#25D366" }} />
                    </a>
                    <a href="https://www.youtube.com/@BiwoERP" target="_blank" rel="noopener noreferrer">
                      <YoutubeOutlined style={{ fontSize: "18px", color: "#FF0000" }} />
                    </a>
                  </div>
                  <div className="login-legal">
                    <p>
                      Consulta los{" "}
                      <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>,{" "}
                      <a href="/avisoDePrivacidad" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>, y{" "}
                      <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer">Política de Cancelación y Devolución</a>.
                    </p>
                  </div>
                  <p className="login-footer">Biwo ©2026</p>
                </div>

              </div>
            </Col>

          </Row>
        </Content>
      </Layout>
    );
  }
}

export default CambiarContrasena;
